export default {
  TitleForm: 'Thông tin bổ sung',
  CashWithDraw: 'Nghiệp vụ',
  MethodPayment: 'Hình thức thanh toán',
  WithDrawNo: 'Số giấy rút',
  CurrentProjectName: 'Tên dự án',
  CurrentSumProjectName: 'Tên viết tắt dự án',
  CurrentProjectCode: 'Mã dự án',
  CompanyName: 'Chủ đầu tư',
  CompanyNo: 'Mã QHNS',
  BudgetYear: 'Năm ngân sách',
  ProjectName: 'CTMT,DA',
  CKCHĐKNo: 'Số CKC, HĐK',
  CKCHĐTHNo: 'Số CKC, HĐTH',
  PaymentCapital: 'Căn cứ giấy đề nghị thanh toán vốn đầu tư số',
  Date: 'Ngày',
  KHVDate: 'Năm KHV',
  ShowReceivingUnit: 'Hiển thị đơn vị nhận tiền (rút tiền mặt)',
  PaymentTax: 'Nộp thuế',
  TaxCode: 'Mã số thuế',
  NDKTCode: 'Mã NDKT',
  ChapterCode: 'Mã chương',
  CQ: 'CQ quản lý thu',
  TaxPeriod: 'Kỳ thuế',
  KBNNCode: 'Mã KBNN hạch toán',
  KBNNSubKindItem: 'KBNN hạch toán khoản thu',
  PaymentToUnit: 'Thanh toán cho đơn vị hưởng',
  UnitName: 'Tên đơn vị',
  UnitRecieve: 'Đơn vị nhận tiền',
  Reciever: 'Người nhận tiền',
  ViewReport: 'Xem báo cáo',

  PrintChapter800: 'In chương 800',
  RepeatTitleSign: 'Lặp lại tiêu đề và chữ ký ở các trang',
  RowOnPage: 'Số dòng trên 1 trang',
  RowLastPage: 'Số dòng trống ở trang cuối',
  NextPage: 'Các trang sau hạ thấp 1/4 trang',
  InfoGeneralTab: 'Thông tin chung',
  DeviceTab: 'Chia ra',
  OptionDisplay: 'Tùy chọn hiển thị',
  Cancel: 'Hủy',
};
